import React from "react";
import "./Error.scss";
import errorImage from "../../assets/images/errorArt.svg";
import { I2cButton, I2cIcon } from "@webcomponents/i2cwebcomponents/dist/react";
import { useNavigate } from "react-router-dom";

const Forbidden = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found not-found--layoutB">
      <div className="not-found__inner--wrap">
        <div className="not-found__img--box">
          <img src={errorImage} className="not-found__image" alt="Error" />
        </div>
        <div className="not-found__content--box">
          <div className="not-found__text--box">
            <h1 className="not-found__title">403</h1>
            <div className="not-found__subtitle">Access Denied</div>
            <p className="not-found__description">
              The server either does not recognize the request method, or it
              lacks the ability to fulfil the request.
            </p>
          </div>
          <div className="not-found__button--wrap">
            <I2cButton
              variant="secondary gray"
              size="small"
              className="not-found__gray__button"
              href="/sales"
            >
              <I2cIcon slot="prefix" name="outline-arrow-left"></I2cIcon> Go
              Back
            </I2cButton>
            <I2cButton
              variant="primary"
              size="small"
              className="not-found__primary__button"
              onClick={() => navigate("/sales")}
            >
              Take me Home
            </I2cButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Forbidden;
